package system.single

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import component.*

class AbilityCooldownSystem: IteratingSystem( family { all(PlayerComponent)}) {
    override fun onTickEntity(entity: Entity) {
        val abilitySelector = entity[PlayerComponent].abilitySelector

        handleCooldowner(abilitySelector.firstAbilityCooldowner)
        handleCooldowner(abilitySelector.secondAbilityCooldowner)
    }

    private fun handleCooldowner(abilityCooldowner: AbilityCooldowner) {
        if (abilityCooldowner != AbilityCooldowner.DISABLED) {
            if (abilityCooldowner.wasUsed) {
                abilityCooldowner.elapsedTime += deltaTime
                if (abilityCooldowner.elapsedTime >= abilityCooldowner.refreshTimeSeconds) {
                    abilityCooldowner.reset()
                }
            }
        }
    }
}
